import { atom } from "recoil";

import { OpsModalName } from "src/constants/OPS";

export const opsModalState = atom<OpsModalName>({
  key: "ops_modal",
  default: null
});
